import { useEffect, useState } from 'react'
import SelectExportType from '../LTLandVolumeTLPages/SelectExportType/SelectExportType'
import DateInput from '../QuotesGridPage/DateInput'
import ShowHideColumns from '../QuotesGridPage/Table/ShowHideColumns'
import SearchInputToolbar from '../LTLandVolumeTLPages/SearchInputToolbar';
import SelectType from '../QuotesGridPage/Table/SelectType'
import { ToolbarProps } from '../../pages/track/models';
import axios from 'axios';
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { format } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';
import { ToolbarStyled } from '../Toolbar.styled'
import { checkErrorAPICall } from '../../helpers/checkErrorAPICall'
import { RootState } from '../../../setup';
import { actionTypes } from '../../modules/auth/redux/PagesRedux';
import { columnsTrackingGrid } from './columnsTrackingGrid';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { stylesMUIInput } from '../stylesMUIInput';
import { UserModel } from '../../modules/auth/models/UserModel';
import { useStyles } from '../LTLandVolumeTLPages/FreightInfo/FreightInformation/FreightInformationStyles';
import { MenuItem, TextField } from '@mui/material';
import { SelectStyled } from '../Inputs.styled';
import SearchShippingLocation from '../NewBookingPage/SearchShippingLocation';
import { useFormik } from 'formik';

let cancelToken
const GET_TRACKINGS = '/applet/v1/book'
const SHIPMENT_MODES = '/api/v1/shipmentmodes'

const Toolbar = ({filters, setFilters, columns, setColumns, trackings, setTrackings, setLoading, rowsPerPage, setPageNumber, setTotalResults, defaultCall, setClicked, setFiltering, defaults, ascOrDesc, field}: ToolbarProps) => {
    const dispatch = useDispatch()
    const trackingsFilter = useSelector<RootState>(({pages}) => pages.trackingsFilter) as any
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const [modes, setModes] = useState([])
    const [shipperFilter, setShipperFilter] = useState<any>({})
    const [shipperFilterLocal, setShipperFilterLocal] = useState('')

    const formik = useFormik({
        initialValues: {
            shipperFilter: {
                id: '',
                name: ''
            }
        },
        onSubmit: () => {}
    })
    const classes = useStyles({
        fontSize: fontSize
    })

    const menuProps = {
        classes: {
            list: classes.selectPaperList
        }
    }

    const handleSearch = (e) => {
        setFilters({...filters, [e.target.name]: e.target.value})
    }

    const getShipmentModes = () => {
        axios.get((SHIPMENT_MODES)).then((result) => {
            setModes(result.data.data.results.map(mode => {
                return mode.name
            }))
        })
      }

    useEffect(() => {
        getShipmentModes()
        if(!trackingsFilter?.search && !trackingsFilter?.type?.length && !trackingsFilter?.dateFrom && !trackingsFilter?.dateTo){
            setFilters({
                ...filters,
                from: new Date(new Date().setMonth(new Date().getMonth() - 1)),
                to: new Date()
            })
            defaultCall({from: new Date().setMonth(new Date().getMonth() - 1), to: new Date()})
            setFiltering(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const updateFiltersFirstCall = () => {
        setPageNumber(0)

        if(isNaN(filters.from) || isNaN(filters.to)){

        }else{
            setLoading(true)

            if (typeof cancelToken != typeof undefined) {
                cancelToken.cancel('Operation canceled due to new request.')
            }
        
            //Save the cancel token for the current request
            cancelToken = axios.CancelToken.source()
        
            axios.get(GET_TRACKINGS, {
                cancelToken: cancelToken.token,
                params: {
                    page: 1,
                    limit: rowsPerPage,
                    search: filters.search.trim(),
                    dateFrom: filters.from && format(filters.from, 'yyyy-MM-dd'),
                    dateTo: filters.to && format(filters.to, 'yyyy-MM-dd'),
                    pickedUp: filters.type.includes('PICKED UP') ? true : filters.type.includes('NOT DISPATCHED') ? false : null,
                    inTransit: filters.type.includes('IN TRANSIT') ? true : null,
                    dispatched: filters.type.includes('DISPATCHED') ? true : filters.type.includes('NOT DISPATCHED') ? false : null,
                    delivered: filters.type.includes('DELIVERED') ? true : filters.type.includes('NOT DISPATCHED') ? false : null,
                    BOLNumber: [filters.bol],
                    'columns[]': [...columnsTrackingGrid.map(col => col.field === 'shipmentMode' ? 'shipmentModeName' : col.field), 'customerQuoteAmount', 'invoiceAmount', 'BOLId', 'UOM'].join('|'),
                    'lastStatus[]': filters?.type?.length && filters?.type[0] === 'DELAYED/EXCEPTION' ? 'DLY|EXPT' : '',
                    'sort[]': ascOrDesc && field ? `${field}:${ascOrDesc}` : 'bookDate:desc',
                    'shipmentModes[]': filters?.mode?.length && (filters?.mode[0] === 'All Modes') ? '' : filters?.mode?.join('|'),
                    shipperId: filters?.shipperFilter?.id || ''
                }
            }).then((results) => {
                setTrackings(results.data.data.results)
                setTotalResults(results.data.data.pagingDetails.totalResults)
                setClicked(false)
                setLoading(false)

                if(results.data.data.results.length){
                    let newSearch = {id: uuidv4(), ...filters, hashId: `${JSON.stringify(filters.search)}${JSON.stringify(filters.from ? filters.from.toDateString() : '')}${JSON.stringify(filters.to ? filters.to.toDateString() : '')}${JSON.stringify(filters.type)}${JSON.stringify(filters.bol)}`}
                    let existingSearches = JSON.parse(localStorage.getItem("historyTrackingGrid")) || []
                    let isDuplicated = existingSearches.find(search => search.hashId === newSearch.hashId)

                    if(isDuplicated){

                    }else{
                        existingSearches.unshift(newSearch);
                        localStorage.setItem("historyTrackingGrid", JSON.stringify(existingSearches));
                    }
                }
            }).catch(error => {
                setLoading(false)
                checkErrorAPICall(error, dispatch, 'Trackings')
            })
        }
    }

    const filter = () => {
        setClicked(true)
        setFiltering(true)
        setPageNumber(0)
        updateFiltersFirstCall()
    }

    useEffect(() => {
        if(ascOrDesc){
          updateFiltersFirstCall()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [ascOrDesc, field])

    useEffect(() => {
        if(shipperFilter?.id){
            setFilters({...filters, shipperFilter: shipperFilter})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shipperFilter])

    useEffect(() => {
        if(shipperFilterLocal === '' && !shipperFilter?.id && filters?.shipperFilter?.id){
            setFilters({...filters, shipperFilter: null})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shipperFilterLocal])

    useEffect(() => {
        if(filters?.shipperFilter?.id && !shipperFilter?.id){
            setShipperFilter(filters.shipperFilter)
            setShipperFilterLocal(filters.shipperFilter?.name || '')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters.shipperFilter])

    return (
        <ToolbarStyled className="row mb-2">
            <div className="col-12 d-flex align-items-center">
                <div style={{width: '180px', marginRight: '16px'}}>
                    <SearchInputToolbar
                        searchTable={filters.search}
                        handleSearch={handleSearch}
                        filter={filter}
                    />
                </div>

                <div className="d-flex align-items-center" style={{width: '280px', marginRight: '16px'}}>
                    <div className="me-2" style={{whiteSpace: 'nowrap'}}>
                        Shipper
                    </div>
                    <div className="w-100">
                        <SearchShippingLocation
                            formik={formik}
                            formFor='shipperFilter'
                            shippingLocation={shipperFilter}
                            setShippingLocation={setShipperFilter}
                            shippingLocationLocal={shipperFilterLocal}
                            setShippingLocationLocal={setShipperFilterLocal}
                            setZipcode={() => {}}
                            setZipcodeLocal={() => {}}
                            inputForDefaults={true}
                            newValuesWhenRateCleared={{valuesFor: '', values: {name: ''}}}
                            setNewValuesWhenRateCleared={() => {}}
                            setOpenClearRateToEditModal={() => {}}
                            setOpenRemarksMessageModal={() => {}}
                        />
                    </div>
                </div>

                <div className="d-flex align-items-center" style={{marginRight: '16px'}}>
                    <div className="me-2" style={{whiteSpace: 'nowrap'}}>
                        From
                    </div>
                    <div style={{width: '130px'}}>
                        <DateInput
                            data={filters}
                            setData={setFilters}
                            dateFor='from'
                        />
                    </div>
                </div>

                <div className="d-flex align-items-center" style={{marginRight: '16px'}}>
                    <div className="me-2" style={{whiteSpace: 'nowrap'}}>
                        To
                    </div>
                    <div style={{width: '130px'}}>
                        <DateInput
                            data={filters}
                            setData={setFilters}
                            dateFor='to'
                        />
                    </div>
                </div>

                <div style={{width: '150px', marginRight: '16px'}}>
                    <SelectType
                        filters={filters}
                        setFilters={setFilters}
                        filterType='type'
                        types={[
                            {value: 'ALL', name: 'All Status'},
                            {value: 'NOT DISPATCHED', name: 'Not Dispatched'},
                            {value: 'DISPATCHED', name: 'Dispatched'},
                            {value: 'PICKED UP', name: 'Picked Up'},
                            {value: 'IN TRANSIT', name: 'In Transit'},
                            {value: 'DELIVERED', name: 'Delivered'},
                            {value: 'DELAYED/EXCEPTION', name: 'Delayed/Exception'}
                        ]}
                        className=''
                    />
                </div>

                <div style={{width: '150px', marginRight: '16px'}}>
                    <TextField
                        select
                        label=" "
                        value={filters.mode || ['All Modes']}
                        onChange={(e) => {
                            let value = e.target.value

                            if(value.length === 0){
                                value = ['All Modes']
                            }

                            if(value.length > 1 && value[0] === 'All Modes'){
                                value = value.filter(value => value !== 'All Modes')
                            }else if(value.length > 1 && value[value.length - 1] === 'All Modes'){
                                value = ['All Modes']
                            }else{
                                if(value.length === modes.length){
                                    value = ['All Modes']
                                }
                            }

                            setFilters({...filters, mode: value})
                        }}
                        className={`${classes.selectMUI}`}
                        InputProps={{
                            style: stylesMUIInput(fontSize),
                        }}
                        SelectProps={{
                            IconComponent: KeyboardArrowDownIcon,
                            MenuProps: menuProps,
                            multiple: true
                        }}
                        InputLabelProps={{shrink: false}}
                    >
                        {['All Modes', ...modes].map((type, index) => <MenuItem key={index} value={type}>{type}</MenuItem>)}
                    </TextField>
                </div>

                <div className="d-flex align-items-center ms-auto">
                    <div
                        className='btn btn-secondary me-3'
                        onClick={() => {
                            dispatch({type: actionTypes.SetTrackingsFilter, payload: []})
                        setShipperFilter({})
                        setShipperFilterLocal('')
                        setFilters({
                            search: '',
                            from: null,
                            to: null,
                            type: ['ALL'],
                            bol: '',
                            shipperFilter: null
                        })
                        setClicked(true)
                        setFiltering(false)
                        setPageNumber(0)
                        defaultCall({emptyValues: true, shipperId: ''})
                    }}
                >
                    Clear
                </div>
                <div
                    className='btn btn-primary me-3'
                    onClick={() => {
                        filter()
                    }}
                >
                    Search
                </div>

                <div style={{marginLeft: '32px', marginRight: '16px'}}>
                    <ShowHideColumns
                        columns={columns}
                        setColumns={setColumns}
                        disabled={trackings.length ? false : true}
                        columnsFor='Tracking Grid'
                        defaults={defaults}
                    />
                </div>
                <SelectExportType
                    fileName="Trackings"
                    columns={columns.filter(column => column?.hidden === false)}
                    dataColumns={trackings}
                    disabled={trackings.length ? false : true}
                    setLoading={setLoading}
                    filters={filters}
                    columnsTrackingGrid={columnsTrackingGrid}
                    ascOrDesc={ascOrDesc}
                    field={field}
                    filtersForData={{
                        search: filters.search.trim(),
                        dateFrom: filters.from instanceof Date && !isNaN(filters.from) && format(filters.from, 'yyyy-MM-dd'),
                        dateTo: filters.to instanceof Date && !isNaN(filters.to) && format(filters.to, 'yyyy-MM-dd'),
                        pickedUp: filters.type.includes('PICKED UP') ? true : filters.type.includes('NOT DISPATCHED') ? false : null,
                        inTransit: filters.type.includes('IN TRANSIT') ? true : null,
                        dispatched: filters.type.includes('DISPATCHED') ? true : filters.type.includes('NOT DISPATCHED') ? false : null,
                        delivered: filters.type.includes('DELIVERED') ? true : filters.type.includes('NOT DISPATCHED') ? false : null,
                        BOLNumber: [filters.bol],
                        'shipmentModes[]': filters?.mode?.length && (filters?.mode[0] === 'All Modes') ? '' : filters?.mode?.join('|'),
                        'columns[]': [...columnsTrackingGrid.map(col => col.field === 'shipmentMode' ? 'shipmentModeName' : col.field), 'customerQuoteAmount', 'invoiceAmount', 'BOLId', 'UOM'].join('|'),
                        'lastStatus[]': filters?.type?.length && filters?.type[0] === 'DELAYED/EXCEPTION' ? 'DLY|EXPT' : '',
                        'sort[]': ascOrDesc && field ? `${field}:${ascOrDesc}` : 'bookDate:desc'
                    }}
                />
                </div>
            </div>
        </ToolbarStyled>
    )
}

export default Toolbar